import React, { useState, useEffect, useRef } from 'react'
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { getIndividualGoal, updateGoal, getGoalStatus } from "../service/PerformanceAPI";
import moment from "moment";
import EvaluationPopUp from "./EvaluationPopUp";
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import Loader from '../StaticComponent/Loader';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../utils/RegHandling';
import { connect } from 'react-redux'
import { encryptStorage } from '../constant'
import { getReportingEmpId } from '../service/DirectorAPI';

function GoalView({ websocket }) {

    const { goalId } = useParams()
    const navigate = useNavigate()
    const { state } = useLocation()


    let dataObj = {
        goalId: "",
        goal_name: "", description: "", assigned_by: "", assigned_date: "", assigned_by_id: "", assigned_to_id: "", assigned_to: "", goalType: "", assignedTo: [], evaluationPeriodId: "", goalTemplateId: ""
        , employee_rating: "", employee_rating_id: "", employee_comments: "", manager_rating_id: "", manager_rating: "", progress: "", manager_comments: "", status_id: "", evaluationStartDate: "",
        evaluationEndDate: "", completed_date: ''
    };
    let details = { role: "", roleId: "", week: 0, domain: "" }
    const [userDetails, setUserDetails] = useState(details)
    const [pageMode, setPageMode] = useState(false);
    const [OldProgress, setOldProgress] = useState();
    const [goalData, setGoalData] = useState(dataObj);
    const [ratings, setRatings] = useState([]);
    const [goalStatus, setGoalStatus] = useState([]);
    const [popUp, setPopUp] = useState(false);
    const [breadCrumbsData, setbreadCrumbsData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [TextArea, setTextArea] = useState(false)

    const [empRatingValidation, setempRatingValidation] = useState('')
    const [empCommentsValidation, setempCommentsValidation] = useState('')
    const [managerCommentsValidation, setmanagerCommentsValidation] = useState('')
    const [managerRatingValidation, setmanagerRatingValidation] = useState('')
    const [statusValidation, setstatusValidation] = useState('')


    useEffect(() => {

        userDetails.roleId = encryptStorage.getItem("employeeId")
        userDetails.role = state?.role
        userDetails.domain = encryptStorage.getItem("department")
        setIsLoading(false)
        getGoalStatus().then(status => {
            setGoalStatus(status.data.ResponseData.goalStatus)
            setRatings(status.data.ResponseData.goalRaing)
        })


        loadGoalData()
    }, [])


    // useEffect(()=>{

    // },[goalData])

    const getEmpReporting = async (res) => {
        let request = {
            login_id: encryptStorage.getItem('employeeId'),
        };
        let respdata = getReportingEmpId(request);

        for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
            if (respdata.data.ResponseData[0][i]?.emp_id === res) {
                return true;
            }
            //
        }

    }


    const loadGoalData = async () => {
        let validReportTo = false;

        setbreadCrumbsData([
            { title: 'Dashboard', path: '/overview', isActive: true },
            { title: 'Team Member', path: '/performance', isActive: true },
            { title: 'Goal', path: '', isActive: false },
        ])
        if (state?.View) {
            let breadcrumbsCreation = state?.profileBreadcrumbs
            breadcrumbsCreation[breadcrumbsCreation.length - 1].isActive = true
            breadcrumbsCreation[breadcrumbsCreation.length - 1].path = `/profilecontainer${state?.redirect}`
            breadcrumbsCreation.push({ title: 'Team Member Goal', path: '', isActive: false })
            setbreadCrumbsData(breadcrumbsCreation)
        }
        if (goalId) {
            getIndividualGoal({ "goalId": goalId }).then((res) => {
                let individualData = {
                    goalId: goalId,
                    goal_name: res.data.ResponseData[0].goal_name,
                    assigned_by_id: res.data.ResponseData[0].assigned_by_id,
                    assigned_by: res.data.ResponseData[0].assigned_by,
                    assigned_to_id: res.data.ResponseData[0].assigned_to_id,
                    assigned_to: res.data.ResponseData[0].assigned_to,
                    description: res.data.ResponseData[0].description,
                    evaluationStartDate: res.data.ResponseData[0].start_date,
                    evaluationEndDate: res.data.ResponseData[0].end_date,
                    employee_rating: res.data.ResponseData[0].employee_rating,
                    employee_comments: res.data.ResponseData[0].employee_comments,
                    manager_rating: res.data.ResponseData[0].manager_rating,
                    manager_comments: res.data.ResponseData[0].manager_comments,
                    progress: res.data.ResponseData[0].progress,
                    status_id: res.data.ResponseData[0].status_id,
                    status: res.data.ResponseData[0].status,
                    assigned_date: res.data.ResponseData[0].assigned_date,
                    completed_date: res.data.ResponseData[0].completed_date

                }
                switch (encryptStorage.getItem('groupid')) {

                    case '1':
                        {
                            validReportTo = true;
                            break;
                        }
                    case '2':
                        {
                            switch (res.data.ResponseData[0]?.goal_type) {
                                case 'team':
                                    {
                                        if (res.data.ResponseData[0]?.assigned_to.includes(encryptStorage.getItem('department'))) {
                                            let request = {
                                                login_id: encryptStorage.getItem('employeeId'),
                                            };
                                            validReportTo = getEmpReporting(res.data.ResponseData[0].assigned_to_id);


                                        }
                                        break;

                                    }
                                case 'individual':
                                    {
                                        if (
                                            (encryptStorage.getItem('employeeId') == res.data.ResponseData[0].assigned_to_id ||
                                                encryptStorage.getItem('employeeId') == res.data.ResponseData[0].assigned_by_id)
                                        ) {
                                            validReportTo = true;
                                        }
                                        else {
                                            validReportTo = getEmpReporting(res.data.ResponseData[0].assigned_to_id);
                                        }
                                        break;

                                    }
                            }









                        }
                    case '3':
                        {
                            if (res.data.ResponseData[0].assigned_to_id == encryptStorage.getItem("employeeId"))
                                validReportTo = true;
                            break
                        }
                    default:
                        {
                            navigate('*')
                            break;
                        }

                }

                if (validReportTo) {
                    setOldProgress(res.data.ResponseData[0].progress)
                    setGoalData({ ...individualData });
                    setPageMode(true);

                    if (res.data.ResponseData[0].progress == 100) {
                        setTextArea(true)
                    }
                    else {
                        setTextArea(false)
                    }
                    setIsLoading(true)
                } else {
                    navigate('/', { state: { hideNav: false } })
                }

            })
        }
    }


    // const OnChangeName = (e) => {
    //     // let a = (e.target.name == 'manager_rating_id') ? goalData.manager_rating = ratings[e.target.value - 1].rating : (e.target.name == 'employee_rating_id') ? goalData.employee_rating = ratings[e.target.value - 1].rating : null
    //     setGoalData({ ...goalData, [e.target.name]: e.target.value });
    // };

    const onChangeProgress = async (e) => {
        setPopUp(false)
        if (e.target.value == 100) {
            setGoalData({ ...goalData, [e.target.name]: e.target.value });
            setPopUp(true)
        }
        else {
            setGoalData({ ...goalData, [e.target.name]: e.target.value });
            setTextArea(false)
            let updateResponse = await updateGoal({ progress: e.target.value, goalId: goalId, status_id: goalData.status_id });
            if (updateResponse.data.ResponseData == "Successfully updated") {
            }
        }
        setGoalData({ ...goalData, [e.target.name]: e.target.value });
    }

    const bindRatings = (value) => {
        return (
            ratings.map(eachRating => {
                return (
                    <li><button name={value} value={eachRating.rating} onClick={(e) => { OnChangeName(e) }} className="dropdown-item text-skyblue tt-bold" type="button"><span><img
                        src={
                            !eachRating.rating
                                ? null : eachRating.rating?.includes('+') ? `/Images/${eachRating.rating?.slice(0, -1)}_plus.png`
                                    : eachRating.rating?.includes('-') ? `/Images/${eachRating.rating?.slice(0, -1)}_minus.png` : null
                        }
                        className="emoji-sty  me-2" /></span>{eachRating.rating}</button></li>
                )
            })
        )
    }

    const validation = (role) => {

        if (role === 'Team Member') {
            let result = true
            if (goalData.employee_rating === '' || goalData.employee_rating === null) {
                result = false
                setempRatingValidation('Ratings is required')
            }
            else setempRatingValidation('')
            if (goalData.employee_comments === '' || goalData.employee_comments === null) {
                result = false
                setempCommentsValidation('Comments is required')
            }
            else {
                let checkregex = OnlyNumberSpecialChar(goalData.employee_comments)
                if (checkregex) {
                    result = false
                    setempCommentsValidation("Comments is not valid")
                } else {
                    setempCommentsValidation("")
                }
            }

            // if (goalData.employee_rating !== '' && goalData.employee_rating !== null &&
            //     goalData.employee_comments !== '' && goalData.employee_comments !== null) {
            //     return true
            // }
            // else return false
            return result

        }
        else if (role === 'Manager') {

            let result = true

            if (goalData.manager_rating === '' || goalData.manager_rating === null) {
                result = false
                setmanagerRatingValidation('Ratings is required')
            }
            else setmanagerRatingValidation('')
            if (goalData.manager_comments === '' || goalData.manager_comments === null) {
                result = false
                setmanagerCommentsValidation('Comments is required')
            }
            else {
                let checkregex = OnlyNumberSpecialChar(goalData.manager_comments)
                if (checkregex) {
                    result = false
                    setmanagerCommentsValidation("Comments is not valid")
                } else {
                    setmanagerCommentsValidation("")
                }
            }

            if (userDetails.roleId === goalData.assigned_by_id) {
                if (goalData.status_id === 1) {
                    result = false
                    setstatusValidation('Status is required')
                }
                else setstatusValidation('')
            }


            if (goalData.manager_rating !== '' && goalData.manager_rating !== null &&
                goalData.manager_comments !== '' && goalData.manager_comments !== null) {

                if (userDetails.roleId === goalData.assigned_by_id) {
                    if (goalData.status_id === 1) {
                        result = false
                        return result
                    }
                    else return result
                }
                else return result
            }
            else return result

        }
        else {
            if (userDetails.roleId === goalData.assigned_by_id) {
                if (goalData.status_id !== 1) {
                    return true
                }
                else {
                    setstatusValidation('Status is required')
                    return false
                }
            }
            else return true
        }
    }

    const submitData = async () => {


        let resultData = validation(userDetails.role)
        if (resultData) {
            if (pageMode) {
                let completed_date;
                if (goalData.status_id === 3) completed_date = moment().format("YYYY-MM-DD"); else completed_date = null

                let obj = {
                    goalId: goalId,
                    progress: goalData.progress,
                    employee_rating: goalData.employee_rating,
                    employee_comments: goalData.employee_comments,
                    manager_rating: (goalData.manager_rating) ? goalData.manager_rating : null,
                    manager_comments: (goalData.manager_comments) ? goalData.manager_comments : null,
                    status_id: goalData.status_id,
                    completed_date: completed_date
                }

                let updateResponse = await updateGoal(obj);

                if (updateResponse.data.ResponseData == "Successfully updated") {
                    encryptStorage.setItem("goalData", "inserted")
                    await NotificationTrigger({ title: "Goal", message: 'Goal evaluation has been updated', route: `/goalview/${goalId}`, state: { state: { role: 'Manager' } }, to_employee: [goalData.assigned_by_id], by: userDetails.roleId }, [goalData.assigned_by_id], websocket)
                    !state?.View ? navigate('/performance') : state?.redirect?.includes('tab') ? window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                }
            }
        }


    }

    const OnChangeName = (e) => {
        setGoalData({ ...goalData, [e.target.name]: e.target.value });
    }

    const showEvaluation = async (value) => {

        setTextArea(value)
        if (value) {
            goalData.progress = 100
            setPopUp(false)
            let updateResponse = await updateGoal({ progress: 100, goalId: goalId, status_id: goalData.status_id });
            if (updateResponse.data.ResponseData == "Successfully updated") {
                setPopUp(false)
                // setFeedback(true)
            }
        }
        else {
            setPopUp(false)
            goalData.progress = OldProgress
        }
    }

    return (
        <>
            {/* <EvaluationPopUp Page={"GoalView"} Click={showEvaluation} /> */}
            {popUp ? <> <EvaluationPopUp Page={"GoalView"} Click={showEvaluation} /> </> : null}
            {isLoading ?
                <div className="container-fluid coverpic mt-5">

                    <div className="row justify-content-center ">
                        <div className="col-md-8 p-4 mt-5 bg-white rounded-3">
                            <BreadCrumbs data={breadCrumbsData} />
                            <h5 className="font-12 text-blue semibold-text mb-3 d-flex">
                                <span className="align-self-center"><img src="/Images/goaltitle.svg" className="goal-target-sty me-2" alt="target-img" /></span>
                                <span className="align-self-center">Goal Title</span></h5>
                            <p className="font-12 text-black semibold-text mb-4">{goalData.goal_name}</p>
                            <h5 className="font-12 text-blue semibold-text">Description</h5>
                            <p className="font-12 text-black semibold-text mb-4">{goalData.description}</p>
                            <div className="row py-1">
                                <div className="col">
                                    <h5 className="font-12 text-blue semibold-text">Assigned to</h5>
                                    <div className="d-flex">
                                        <div className="d-block">
                                            <img src="/Images/logo-person-user-person-icon.jpg" className="goal-profile-pic me-2" />
                                        </div>
                                        <div className="d-block align-self-center">
                                            <label className="font-14 semibold-text data-blue">{goalData.assigned_to}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <h5 className="font-12 text-blue semibold-text">Assigned by</h5>
                                    <div className="d-flex">
                                        <div className="d-block">
                                            <img src="/Images/logo-person-user-person-icon.jpg" className="goal-profile-pic me-2" />
                                        </div>
                                        <div className="d-block align-self-center">
                                            <label className="font-14 semibold-text data-blue">{goalData.assigned_by}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <h5 className="font-12 text-blue semibold-text">Assigned Date</h5>
                                    <label className="font-14 semibold-text data-blue">{moment(goalData.assigned_date).format("MMM DD,YYYY")}</label>
                                </div>
                                <div className="col">
                                    <h5 className="font-12 text-blue semibold-text">Completed Date</h5>
                                    <label className="font-14 semibold-text data-blue">{goalData.completed_date ? moment(goalData.completed_date).format("MMM DD, YYYY") : "-"}</label>
                                </div>
                                {userDetails.role != 'Manager' ?
                                    <div className="col">
                                        <h5 className="font-12 text-blue semibold-text">Goal Status</h5>
                                        <label className="font-14 semibold-text table-link-clr">{goalData.status}</label>
                                    </div> : null}
                            </div>
                            <div className="row pt-4">
                                <div className="col-md-6 pb-4">
                                    <label htmlFor="customRange2" className="form-label font-12 text-blue semibold-text">Progress</label>
                                    <div className>
                                        <input disabled={goalData.status == 'Completed' || userDetails.role == 'Hr Manager' || userDetails.role == 'Manager' ? true : false} type="range" defaultValue={0} data-bs-toggle={popUp ? "modal" : "modal"} data-bs-target={popUp ? "#goalView100" : null} className="range" name='progress' value={parseInt(goalData.progress)} onChange={(e) => { onChangeProgress(e) }} />
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <label>0%</label>
                                        <label>{goalData.progress}%</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 pt-4 bg-white mt-4 rounded-3 p-0 mb-5">
                            <div className="col-md-12">
                                <h5 className="font-15 tt-bold goal-evaluation-title pb-3 text-blue">Goal Evaluation</h5>
                            </div>
                            <div className="card-group px-0">
                                <div className="card border-start-0 px-3 rounded-0">
                                    <div className="card-body">
                                        {(userDetails.role === 'Team Member') ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Team Member Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <label className="form-label hive-form-label">Rating<span className="hive-form-mandatory"> *</span></label>
                                            <div className="dropdown mb-4 dropdown-box-sty">
                                                <button disabled={TextArea ? false : true} className={goalData.status !== 'Completed' ? `btn dropdown-toggle dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start` : `btn dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start`} type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {goalData.employee_rating !== null && goalData.employee_rating !== '' ? <span> <img

                                                        src={
                                                            !goalData?.employee_rating
                                                                ? null : goalData?.employee_rating?.includes('+') ? `/Images/${goalData?.employee_rating?.slice(0, -1)}_plus.png`
                                                                    : goalData?.employee_rating?.includes('-') ? `/Images/${goalData?.employee_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" />
                                                    </span> : <span> <img className=" me-2" />
                                                    </span>}
                                                    <span className="text-skyblue">{goalData.employee_rating}</span>
                                                </button>
                                                {goalData.status !== 'Completed' ?
                                                    <ul className="dropdown-menu w-50" aria-labelledby="dropdownMenu2">
                                                        {bindRatings("employee_rating")}
                                                    </ul> : null}
                                                <label className='row text-danger ps-3'>{empRatingValidation}</label>
                                            </div>
                                            <label htmlFor="comments" className="form-label hive-form-label">Comments<span className="hive-form-mandatory"> *</span></label>
                                            <textarea maxLength={255} disabled={goalData.status !== 'Completed' && TextArea ? false : true} className="form-control hive-form-control custom-comment-box" id="comments" placeholder="Enter Comments" value={goalData.employee_comments} name='employee_comments' onChange={(e) => { setempCommentsValidation(''); OnChangeName(e) }} rows={4} defaultValue={""} />
                                            <label className='text-danger'>{empCommentsValidation}</label>
                                        </> : (userDetails.role === 'Manager' && (goalData.employee_rating === '' || goalData.employee_rating === null || goalData.employee_comments === '')) ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Team Member Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <div className="row justify-content-center">
                                                <img src="/Images/nodatafound.png" alt="nofeedback-found" className="nofeedbackimg-sty" />
                                                <h2 className="tt-bold font-15 text-center">No Feedback Found</h2>
                                            </div>
                                        </> : (userDetails.role === 'Manager') ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Team Member Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <label className="form-label hive-form-label">Rating<span className="hive-form-mandatory"> *</span></label>
                                            <div className="dropdown mb-4 dropdown-box-sty">
                                                <button className="btn dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <span><img
                                                        src={
                                                            !goalData?.employee_rating
                                                                ? null : goalData?.employee_rating?.includes('+') ? `/Images/${goalData?.employee_rating?.slice(0, -1)}_plus.png`
                                                                    : goalData?.employee_rating?.includes('-') ? `/Images/${goalData?.employee_rating?.slice(0, -1)}_minus.png` : null
                                                        }

                                                        className="emoji-sty  me-2" /></span><span className="text-skyblue">{goalData.employee_rating}</span>
                                                </button>
                                            </div>
                                            <label htmlFor="comments" className="form-label hive-form-label">Comments<span className="hive-form-mandatory"> *</span></label>
                                            <textarea disabled value={goalData.employee_comments} className="form-control hive-form-control custom-comment-box" id="comments" placeholder="Enter Comments" rows={4} />
                                        </> : null}
                                        {(userDetails.role === 'Hr Manager' && (goalData.employee_rating !== '' && goalData.employee_rating != null && goalData.employee_comments !== '')) ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Team Member Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <label className="form-label hive-form-label">Rating<span className="hive-form-mandatory"> *</span></label>
                                            <div className="dropdown mb-4 dropdown-box-sty">
                                                <button className="btn dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <span><img

                                                        src={
                                                            !goalData?.employee_rating
                                                                ? null : goalData?.employee_rating?.includes('+') ? `/Images/${goalData?.employee_rating?.slice(0, -1)}_plus.png`
                                                                    : goalData?.employee_rating?.includes('-') ? `/Images/${goalData?.employee_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" /></span><span className="text-skyblue">{goalData.employee_rating}</span>
                                                </button>
                                            </div>
                                            <label htmlFor="comments" className="form-label hive-form-label">Comments<span className="hive-form-mandatory"> *</span></label>
                                            <textarea disabled value={goalData.employee_comments} className="form-control hive-form-control custom-comment-box" id="comments" placeholder="Enter Comments" rows={4} defaultValue={""} />
                                        </> : (userDetails.role === 'Hr Manager') ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Team Member Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <div className="row justify-content-center">
                                                <img src="/Images/nodatafound.png" alt="nofeedback-found" className="nofeedbackimg-sty" />
                                                <h2 className="tt-bold font-15 text-center">No Feedback Found</h2>
                                            </div>
                                        </> : null}
                                    </div>
                                </div>
                                <div className="card border-end-0 px-3 rounded-0">
                                    <div className="card-body">
                                        {(userDetails.role == 'Manager') ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Manager Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <label className="form-label hive-form-label">Rating<span className="hive-form-mandatory"> *</span></label>
                                            <div className="dropdown mb-4 dropdown-box-sty">
                                                <button disabled={TextArea ? false : true} name='manager_rating' className={goalData.status !== 'Completed' ? `btn dropdown-toggle dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start` : `btn dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start`} type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {goalData.manager_rating !== null && goalData.manager_rating !== '' ? <span> <img

                                                        src={
                                                            !goalData?.manager_rating
                                                                ? null : goalData?.manager_rating?.includes('+') ? `/Images/${goalData?.manager_rating?.slice(0, -1)}_plus.png`
                                                                    : goalData?.manager_rating?.includes('-') ? `/Images/${goalData?.manager_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" />
                                                    </span> : <span> <img className=" me-2" />
                                                    </span>}
                                                    <span className="text-skyblue">{goalData.manager_rating}</span>
                                                </button>
                                                {goalData.status !== 'Completed' ?
                                                    <>
                                                        <ul className="dropdown-menu w-50" aria-labelledby="dropdownMenu2">
                                                            {bindRatings("manager_rating")}
                                                        </ul>
                                                        <label className='row text-danger ps-3'>{managerRatingValidation}</label>
                                                    </>
                                                    : null}
                                            </div>
                                            <label htmlFor="comments" className="form-label hive-form-label">Comments<span className="hive-form-mandatory"> *</span></label>
                                            <textarea maxLength={255} disabled={goalData.status !== 'Completed' && TextArea ? false : true} className="form-control hive-form-control custom-comment-box" id="comments" name='manager_comments' value={goalData.manager_comments} onChange={(e) => { setmanagerCommentsValidation(''); OnChangeName(e) }} placeholder="Enter Comments" rows={4} defaultValue={""} />
                                            <label className='text-danger'>{managerCommentsValidation}</label>
                                        </> : (userDetails.role === 'Team Member' && (goalData.manager_rating === '' || goalData.manager_rating === null || goalData.manager_comments === '')) ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Manager Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <div className="row justify-content-center">
                                                <img src="/Images/nodatafound.png" alt="nofeedback-found" className="nofeedbackimg-sty" />
                                                <h2 className="tt-bold font-15 text-center">No Feedback Found</h2>
                                            </div>
                                        </> : (userDetails.role === 'Team Member') ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Manager Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <label className="form-label hive-form-label">Rating<span className="hive-form-mandatory"> *</span></label>
                                            <div className="dropdown mb-4 dropdown-box-sty">
                                                <button className="btn dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <span><img

                                                        src={
                                                            !goalData?.manager_rating
                                                                ? null : goalData?.manager_rating?.includes('+') ? `/Images/${goalData?.manager_rating?.slice(0, -1)}_plus.png`
                                                                    : goalData?.manager_rating?.includes('-') ? `/Images/${goalData?.manager_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" /></span><span className="text-skyblue">{goalData.manager_rating}</span>
                                                </button>
                                            </div>
                                            <label htmlFor="comments" className="form-label hive-form-label">Comments<span className="hive-form-mandatory"> *</span></label>
                                            <textarea disabled value={goalData.manager_comments} className="form-control hive-form-control custom-comment-box" id="comments" placeholder="Enter Comments" rows={4} />
                                        </> : null}
                                        {(userDetails.role == 'Hr Manager' && goalData.manager_rating != '' && goalData.manager_rating != null && goalData.manager_comments != '') ? <>
                                            <h5 className="font-15 tt-bold pb-3 text-blue">Manager Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                            <label className="form-label hive-form-label">Rating<span className="hive-form-mandatory"> *</span></label>
                                            <div className="dropdown mb-4 dropdown-box-sty">
                                                <button className="btn dropdown-icon-sty tt-bold goal-dropdown-sty text-black w-50 text-start" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <span><img
                                                        src={
                                                            !goalData?.manager_rating
                                                                ? null : goalData?.manager_rating?.includes('+') ? `/Images/${goalData?.manager_rating?.slice(0, -1)}_plus.png`
                                                                    : goalData?.manager_rating?.includes('-') ? `/Images/${goalData?.manager_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" /></span><span className="text-skyblue">{goalData.manager_rating}</span>
                                                </button>
                                            </div>
                                            <label htmlFor="comments" className="form-label hive-form-label">Comments<span className="hive-form-mandatory"> *</span></label>
                                            <textarea disabled className="form-control hive-form-control custom-comment-box" id="comments" placeholder="Enter Comments" rows={4} value={goalData.manager_comments} />
                                        </> :
                                            (userDetails.role == 'Hr Manager') ? <>
                                                <h5 className="font-15 tt-bold pb-3 text-blue">Manager Evaluation<span><img src="/Images/help.svg" className="ps-2" alt="Evaluation info" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="info " aria-label="info " /></span></h5>
                                                <div className="row justify-content-center">
                                                    <img src="/Images/nodatafound.png" alt="nofeedback-found" className="nofeedbackimg-sty" />
                                                    <h2 className="tt-bold font-15 text-center">No Feedback Found</h2>
                                                </div>
                                            </> : null}
                                    </div>
                                </div>
                            </div>
                            {(userDetails.roleId === goalData.assigned_by_id) ? <div className="mx-3 my-3 col-md-3">
                                {goalData.status !== 'Completed' ?
                                    <>
                                        <label className="form-label hive-form-label" htmlFor="status">Status</label>
                                        <select className="form-select hive-form-select" aria-label="Default select example2" value={goalData.status_id} onChange={(e) => { setstatusValidation(''); OnChangeName(e) }} name='status_id' >
                                            <option selected>Select</option>
                                            {goalStatus.map(status => {
                                                return (
                                                    <option value={status.id}>{status.heading}</option>
                                                )
                                            })}
                                        </select>
                                        <label className='row text-danger ps-3'>{statusValidation}</label>
                                    </>
                                    : null}
                            </div> : null}
                            <div className="col-md-12 py-2 d-flex justify-content-end my-3">
                                <a href={!state?.View ? '/performance' : state?.redirect?.includes('tab') ? `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : `/profilecontainer${state.redirect}&tab=performance`}><button className="btn  hive-btn-secondary me-3">Cancel</button></a>
                                {goalData.status !== 'Completed' && (userDetails.roleId === goalData.assigned_by_id || userDetails.role === 'Team Member' || userDetails.role === 'Manager') ? <button className="btn  hive-btn-primary me-4" onClick={() => { submitData() }}>Submit</button> : null}
                            </div>
                        </div>
                    </div>
                </div> : <Loader isLoading={isLoading} />}
        </>
    )
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(GoalView)